import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  emailList: { loading: false, data: null, error: null },
  emailListCreate: { loading: false, data: null, error: null },
  editEmailListStatus: { loading: false, data: null, error: null },
};

export const EmailListSlice = createSlice({
  name: "emaillist",
  initialState,
  reducers: {
    fetchEmailListRequest: (state, action) => {
      state.emailList.loading = true;
      state.emailList.error = null;
    },
    fetchEmailListSuccess: (state, action) => {
      state.emailList.data = action.payload;
      state.emailList.loading = false;
      state.emailList.error = null;
    },
    fetchEmailListFailure: (state, action) => {
      state.emailList.data = null;
      state.emailList.loading = false;
      state.emailList.error = action.payload;
    },
    EmailListCreateRequest: (state, action) => {
      state.emailListCreate.loading = true;
      state.emailListCreate.error = null;
    },
    EmailListCreateSuccess: (state, action) => {
      state.emailListCreate.data = action.payload;
      state.emailListCreate.loading = false;
      state.emailListCreate.error = null;
      state.emailList = addNewEmailListSuccess(action.payload, {
        ...state.emailList,
      });
    },
    EmailListCreateFailure: (state, action) => {
      state.emailListCreate.data = null;
      state.emailListCreate.loading = false;
      state.emailListCreate.error = action.payload;
    },
    editEmailListStatusRequest: (state, action) => {
      state.editEmailListStatus.loading = true;
      state.editEmailListStatus.error = null;
    },
    editEmailListStatusSuccess: (state, action) => {
      state.editEmailListStatus.data = action.payload;
      state.editEmailListStatus.loading = false;
      state.editEmailListStatus.error = null;
      state.emailList = updateEmailListSuccess(action.payload, {
        ...state.emailList,
      });
    },
    editEmailListStatusFaliure: (state, action) => {
      state.editEmailListStatus.data = null;
      state.editEmailListStatus.loading = false;
      state.editEmailListStatus.error = action.payload;
    },
  },
});

function addNewEmailListSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

function updateEmailListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchEmailListRequest,
  fetchEmailListSuccess,
  fetchEmailListFailure,
  EmailListCreateRequest,
  EmailListCreateSuccess,
  EmailListCreateFailure,
  editEmailListStatusRequest,
  editEmailListStatusSuccess,
  editEmailListStatusFaliure,
} = EmailListSlice.actions;

export const getEmailListState = (store) => store.emaillist?.emailList;
export const getEmailListCreateState = (store) =>
  store.emaillist?.emailListCreate;
export const editInvoiceStatusState = (store) =>
  store.invoice?.editInvoiceStatus;

export default EmailListSlice.reducer;
